import { render } from "./EditFillableDocument.vue?vue&type=template&id=63d06734"
import script from "./EditFillableDocument.vue?vue&type=script&lang=js"
export * from "./EditFillableDocument.vue?vue&type=script&lang=js"

import "./EditFillableDocument.vue?vue&type=style&index=0&id=63d06734&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__